@if (show) {
  <div class="text-center" [class.flex]="oneRow" [class.align-items-center]="oneRow" [class.gap-2]="oneRow">
    @if (playingVenueIntern.infoSmokers || showAllInfos) {
      @if (playingVenueIntern.infoSmokers) {
        <div class="cursor-pointer" [pTooltip]="'SMOKERS' | translate" >
          <span class="material-icons text-green-500" [class.text-sm]="small" >smoking_rooms</span>
        </div>
      }
      @else {
        <div class="cursor-pointer" [pTooltip]="'NO_SMOKERS' | translate" >
          <span class="material-icons text-red-500" [class.text-sm]="small" >smoke_free</span>
        </div>
      }
    }
    @if (playingVenueIntern.infoInternet || showAllInfos) {
      @if (playingVenueIntern.infoInternet) {
        <div class="cursor-pointer" [pTooltip]="'INTERNET' | translate" >
          <span class="material-icons text-green-500" [class.text-sm]="small" >wifi</span>
        </div>
      }
      @else {
        <div class="cursor-pointer" [pTooltip]="'NO_INTERNET' | translate" >
          <span class="material-icons text-red-500"  [class.text-sm]="small">wifi_off</span>
        </div>
      }
    }
    @if (playingVenueIntern.infoAccessible || showAllInfos) {
      @if (playingVenueIntern.infoAccessible) {
        <div class="cursor-pointer" [pTooltip]="'ACCESSIBILITY' | translate" >
          <span class="material-icons text-green-500" [class.text-sm]="small" >accessible</span>
        </div>
      }
      @else {
        <div class="cursor-pointer" [pTooltip]="'NO_ACCESSIBILITY' | translate" >
          <span class="material-icons text-red-500" [class.text-sm]="small" >not_accessible</span>
        </div>
      }
    }
    @if (playingVenueIntern.infoU18 || showAllInfos) {
      @if (playingVenueIntern.infoU18) {
        <div class="cursor-pointer" [pTooltip]="'U18' | translate" >
          <!--<span class="material-icons text-green-500" [class.text-sm]="!small" [class.text-sm]="small" >family_star</span>-->
          <span class="text-green-500 font-bold" [class.text-sm]="small" >U18</span>
        </div>
      }
      @else {
        <div class="cursor-pointer" [pTooltip]="'NO_U18' | translate" >
          <!--<span class="material-icons text-red-500" [class.text-sm]="!small" [class.text-sm]="small" >family_star</span>-->
          <span class="text-red-500 font-bold strikethrough" [class.text-sm]="small" >U18</span>
        </div>
      }
    }
    @if (playingVenueIntern.infoFood || showAllInfos) {
      @if (playingVenueIntern.infoFood) {
        <div class="cursor-pointer" [pTooltip]="'FOOD' | translate" >
          <span class="material-icons text-green-500" [class.text-sm]="small" >restaurant</span>
        </div>
      }
      @else {
        <div class="cursor-pointer" [pTooltip]="'NO_FOOD' | translate" >
          <span class="material-icons text-red-500" [class.text-sm]="small" >no_meals</span>
        </div>
      }
    }
  </div>
}
